import React from 'react';
import { useWebLocale } from '../../contexts/WebLocaleContext';
import './BrowseListState.css';
export default function BrowseListState({ query, kind, children }) {
  const { locale } = useWebLocale(),
    en = locale === 'en';
  const failed =
    kind === 'albums'
      ? en
        ? 'Could not load albums.'
        : '앨범을 불러오지 못했어요.'
      : en
        ? 'Could not load reviews.'
        : '리뷰를 불러오지 못했어요.';
  return (
    <>
      {query.isError && (
        <div role="alert" className="pp-browse-list-status">
          {failed}
          {query.data && (
            <span>{en ? 'Showing the previous result.' : '기존 조회 결과를 유지하고 있어요.'}</span>
          )}
          <button
            type="button"
            className="pp-action"
            disabled={query.isFetching}
            onClick={() => query.refetch({ cancelRefetch: false })}
          >
            {en ? 'Retry' : '다시 시도'}
          </button>
        </div>
      )}
      {query.isFetching && (
        <div role="status" className="pp-browse-list-status">
          {en ? 'Loading…' : '불러오는 중…'}
        </div>
      )}
      {!query.initialLoading && (!query.isError || query.data) && children}
    </>
  );
}

export function BrowseEmpty({ kind }) {
  const { locale } = useWebLocale(),
    en = locale === 'en';
  const title =
    kind === 'albums'
      ? en
        ? 'No albums match these filters'
        : '조건에 맞는 앨범이 없습니다'
      : en
        ? 'No member reviews match these filters'
        : '조건에 맞는 회원 리뷰가 없습니다';
  return (
    <div className="pp-browse-empty">
      <strong>{title}</strong>
      <p>
        {en
          ? 'Change the filters or check again later.'
          : '필터를 바꾸거나 잠시 후 다시 확인해 주세요.'}
      </p>
    </div>
  );
}
